// AuraMax AI client — talks to the backend Aura Coach endpoints.
const API = process.env.REACT_APP_BACKEND_URL;

async function postJSON(path, body) {
  const res = await fetch(`${API}/api${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = "Something went wrong.";
    try { detail = (await res.json()).detail || detail; } catch (e) {}
    throw new Error(detail);
  }
  return res.json();
}

export const generateCaption = (idea, tone, interest) =>
  postJSON("/ai/caption", { idea, tone, interest });

export const smartReplies = (context, kind = "comment") =>
  postJSON("/ai/replies", { context, kind });

export const contentIdeas = (interest, count = 5) =>
  postJSON("/ai/ideas", { interest, count });

export const generateImage = (prompt, kind = "post") =>
  postJSON("/ai/image", { prompt, kind });

export const editImage = (prompt, image, kind = "post") =>
  postJSON("/ai/image/edit", { prompt, image, kind });

// Streaming Aura Coach chat. Calls onDelta(token) as tokens arrive.
export async function streamCoach({ sessionId, message, onSession, onDelta }) {
  const res = await fetch(`${API}/api/ai/coach`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId || null, message }),
  });
  if (!res.ok || !res.body) throw new Error("Aura Coach is unavailable right now.");

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split("\n\n");
    buffer = chunks.pop();
    for (const chunk of chunks) {
      const line = chunk.trim();
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (payload === "[DONE]") return;
      try {
        const obj = JSON.parse(payload);
        if (obj.session_id && onSession) onSession(obj.session_id);
        if (obj.delta && onDelta) onDelta(obj.delta);
        if (obj.error) throw new Error(obj.error);
      } catch (e) { /* ignore partial */ }
    }
  }
}
